import {
  parseCommandEnqueued,
  parseDeviceCommandsView,
} from '../../shared/wire';
import type { CommandResult } from '../../shared/wire';

// V1 catalog: a query (battery) + a command (noop). The dropdown is scoped to
// the device's advertised tiers.
export const COMMAND_CATALOG: { kind: string; tier: 'query' | 'command'; label: string }[] = [
  { kind: 'battery', tier: 'query', label: 'Battery level' },
  { kind: 'noop', tier: 'command', label: 'No-op (ping)' },
];

export async function apiEnqueueCommand(token: string, tier: 'query' | 'command', kind: string, args?: string){
  const body: { tier: string; kind: string; args?: string } = { tier, kind };
  if(args !== undefined) body.args = args;
  const res = await fetch(`/api/v1/devices/${encodeURIComponent(token)}/commands`, {
    method: 'POST', credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if(!res.ok){ const e: any = new Error('enqueue ' + res.status); e.status = res.status; throw e; }
  return parseCommandEnqueued(await res.json());
}

export async function apiGetDeviceCommands(token: string, since?: number){
  const qs = since !== undefined ? `?since=${since}` : '';
  const res = await fetch(`/api/v1/devices/${encodeURIComponent(token)}/commands${qs}`, { credentials: 'include' });
  if(!res.ok){ const e: any = new Error('commands ' + res.status); e.status = res.status; throw e; }
  return parseDeviceCommandsView(await res.json());
}

// Per-kind result formatter: battery → "72% · charging"; unknown/parse-fail →
// the raw result_data (escaped by the caller).
export function formatCommandResult(kind: string, result_data: string | null): string {
  if(result_data == null) return '—';
  if(kind === 'battery'){
    try {
      const o = JSON.parse(result_data);
      if(o && typeof o.percent === 'number') return `${o.percent}%${o.charging ? ' · charging' : ''}`;
    } catch { /* fall through to raw */ }
  }
  return result_data;
}

// Events visible at the replay scrub position (web spec `commandsAtCutoff`):
// issued at-or-before cutoffT; result fields blanked until acked_at <= cutoffT,
// so a response only "lands" once the scrubber passes the moment it arrived.
export function commandsAtCutoff(history: CommandResult[], cutoffT: number): CommandResult[] {
  if(cutoffT === Infinity) return history;
  return history
    .filter(c => c.issued_at <= cutoffT)
    .map(c => (c.acked_at != null && c.acked_at <= cutoffT) ? c : { ...c, acked_at: null, result_data: null });
}
